module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_plan_show_bg_02-f8ab06c2d7760bee55267be65b64a9d1.jpg";